// extracted by css-extract-rspack-plugin
export default {"tree":"d0lFx5fvOwMqFAus","item":"s_jytl6k7EgjBtOz yjEOWr1wvMI7B708","content":"fVSP4nVA1i0_ljAk","chevron":"J2c9Yau71543dLu0"};